let OtherInvoiceTypes = [
	{ id: "0", name: "01 其他发票" },
	{ id: "1", name: "02 停车费发票" },
	{ id: "2", name: "03 市内交通发票" },
	{ id: "3", name: "04 出租车发票" },
	{ id: "4", name: "05 长途车票" },
	{ id: "5", name: "06 高铁、火车车票" },
	{ id: "6", name: "07 航空服务发票" },
	{ id: "7", name: "08 高速公路发票" },
	{ name: "09 办公用品类发票", id: "8" },
	{ name: "10 食品类发票（除烟、酒外）", id: "9" },
	{ name: "11 日用品类发票", id: "10" },
	{ name: "12 餐饮服务类发票", id: "11" },
	{ name: "13 燃料、动力类发票", id: "12" },
	{ name: "14 住宿服务类发票", id: "13" },
	{ name: "15 水电服务类发票", id: "14" }
];

export default OtherInvoiceTypes;
